import styled from "styled-components";

import Row from "components/Form/Row";

export const Container = styled.div`
  width: 450px;
  margin-bottom: 40px;
`;

export const TitleWrapper = styled.div``;

export const TitleContainer = styled.div`
  margin-bottom: 20px;
`;

export const ControlRow = styled(Row)`
  margin-bottom: 30px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const TimeControlWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  margin-left: 16px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;
